<template>
	<page gradient-background>
		<detail-base :count="{name: '预估收费', value: `￥${baseInfo.estimated_fee || '-'}`}">
			<template #state>
				<c-state dict="orderTransferStatusDic" tag :value="baseInfo.order_transfer_status"></c-state>
				<c-state dict="serviceTypeDic" tag :value="baseInfo.service_type_code"></c-state>
			</template>

			<template #title><i class="tf">&#xe67c;</i> {{baseInfo.customer_name}}</template>

			<template #info>
				<c-field v-if="baseInfo.work_order_no" label="关联工单"><c-link v-if="baseInfo.work_order_id" @click="mp.navigateWeb('/aftersales/work/detail', {id: baseInfo.work_order_id})">{{baseInfo.work_order_no}}</c-link></c-field>
				<c-field label="客户电话"><a v-if="baseInfo.customer_phone" :href="`tel:${baseInfo.customer_phone}`">{{baseInfo.customer_phone}} [{{baseInfo.customer_contact}}]<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-field>
				<c-field label="售后地址"><a @click="mapHandle">{{baseInfo.aftersale_address}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe6d7;</i></a></c-field>
				<c-field label="分配网点">{{baseInfo.authorized_outlet_name}}</c-field>
			</template>
		</detail-base>

		<detail-content :tabs="tabList">
			<template #base>
				<c-title>基础信息</c-title>
				<c-detail>
				<c-detail-item label="申请单编号">{{baseInfo.aftersale_apply_no}}</c-detail-item>
				<c-detail-item label="申请单状态">{{baseInfo.apply_status}}</c-detail-item>
				<c-detail-item label="服务类型">{{baseInfo.service_type}}</c-detail-item>
				<c-detail-item label="售后类别"><c-state dict="afterSaleTypeDic" :value="baseInfo.aftersale_type_code"></c-state></c-detail-item>
				<c-detail-item label="服务内容">{{baseInfo.service_content}}</c-detail-item>
				<c-detail-item label="是否收费">{{baseInfo.is_charge}}</c-detail-item>
				<c-detail-item label="预估收费金额">￥{{baseInfo.estimated_fee}}</c-detail-item>
				<c-detail-item label="预估人数">{{baseInfo.estimated_person}}</c-detail-item>
				<c-detail-item label="预估到达时间">{{baseInfo.eost_date}}</c-detail-item>
				<c-detail-item label="实收上门服务费">￥{{baseInfo.actual_visit_fee}}</c-detail-item>
				<c-detail-item label="备注">{{baseInfo.remark}}</c-detail-item>
                <c-detail-item label="意见处理单">{{baseInfo.complaint_no}}</c-detail-item>
                <c-detail-item label="销售部门编号">{{baseInfo.sales_dept_no}}</c-detail-item>
			</c-detail>

				<c-title>客户信息</c-title>
				<c-detail>
				<c-detail-item label="客户名称">{{baseInfo.customer_name}}</c-detail-item>
				<c-detail-item label="所属部门">{{baseInfo.depart_name}}</c-detail-item>
				<c-detail-item label="联系人">{{baseInfo.customer_contact}}</c-detail-item>
				<c-detail-item label="联系电话"><a v-if="baseInfo.customer_phone" :href="`tel:${baseInfo.customer_phone}`">{{baseInfo.customer_phone}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-detail-item>
				<c-detail-item label="售后地址">{{baseInfo.aftersale_address}}</c-detail-item>
				<c-detail-item label="地址定位">{{baseInfo.address_longitude}}, {{baseInfo.address_latitude}}</c-detail-item>
				<c-detail-item label="网点-客户距离">{{baseInfo.net_address_count}}km</c-detail-item>
			</c-detail>

				<c-title>业务信息</c-title>
				<c-detail>
				<c-detail-item label="服务类别">{{baseInfo.service_category}}</c-detail-item>
				<c-detail-item label="业务员姓名">{{baseInfo.salesman_name}}</c-detail-item>
				<c-detail-item label="业务员电话"><a v-if="baseInfo.salesman_phone" :href="`tel:${baseInfo.salesman_phone}`">{{baseInfo.salesman_phone}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-detail-item>
				<c-detail-item label="申请单所有人">{{baseInfo.apply_owner}}</c-detail-item>
				<c-detail-item label="创建时间">{{baseInfo.apply_create_time}}</c-detail-item>
				<c-detail-item label="审核人">{{baseInfo.apply_auditor}}</c-detail-item>
				<c-detail-item label="审核时间">{{baseInfo.apply_audit_time}}</c-detail-item>
			</c-detail>

				<c-title>售后服务明细 ({{productList.length}})</c-title>
				<div>
					<goods-card
						v-for="(item, i) in productList"
						:key="i"
						:index="i + 1"
						:title="`${item.inventory_name || '-'} ${item.spec_model != item.inventory_name ? item.spec_model || '-' : ''}`"
						:info="[
							`长：${item.length || '-'}mm`,
							`宽：${item.width || '-'}mm`,
							`件数：${item.quantity || '-'}`,
							`环接方式：${item.connection_method || '-'}`,
							`数量：${item.pieces || '-'}`
						]"
						:remark="item.item_remark"
					></goods-card>
				</div>
			</template>

			<template #log>
				<c-scroll-list ref="logList" :refresh="false">
					<template #default="{data, index}">
						<log-item
							:key="index"
							:date="data.create_date"
							:person="data.create_user_realname"
							:action="data.remark"
						>
							<template v-if="data.data_list && data.data_list.length" #remark>
								<c-field v-for="(item, i) in data.data_list" :key="i" :label="item.label">{{item.content}}</c-field>
							</template>
							<template v-if="data.img_list" #image>
								<c-file v-for="(item, i) in data.img_list" :key="i" :src="item" media></c-file>
							</template>
						</log-item>
					</template>
				</c-scroll-list>
			</template>
		</detail-content>

		<detail-handle>
			<template>
				<c-button v-if="auth('b_app_aftersale_apply_transfer') && baseInfo.order_transfer_status == 0 && baseInfo.is_suspended != 1" size="detail" color="main" @click="mp.navigateWeb('/aftersales/work/edit', {source: baseInfo.id})">转售后工单</c-button>
				<c-button v-if="auth('b_app_aftersale_apply_authorize') && baseInfo.order_transfer_status == 0 && baseInfo.is_suspended != 1" @click="$refs.applyAllot.open(baseInfo.id)">分配网点</c-button>
				<c-button v-if="auth('b_app_aftersale_apply_suspend') && baseInfo.is_suspended != 1" @click="suspendHandle">挂起</c-button>
				<c-button v-if="auth('b_app_aftersale_apply_suspend') && baseInfo.is_suspended == 1" color="main" @click="resumeHandle">恢复</c-button>
			</template>
		</detail-handle>

		<apply-allot ref="applyAllot" @resolve="update"></apply-allot>

		<c-dialog ref="suspend" title="挂起申请单" height="5rem" button-name="确认挂起">
			<c-form ref="suspendForm">
				<c-form-item label="备注">
					<c-input type="textarea" name="suspend_reason" placeholder="请填写备注信息"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import applyAllot from './apply_allot.vue'

	export default {
		components: {
			applyAllot
		},
		
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {},
				productList: []
			}
		},

		computed: {
			tabList() {
				return [{
					name: '基础资料',
					value: 'base'
				}, {
					name: '跟进日志',
					value: 'log'
				}]
			}
		},

		mounted() {
			this.update();
			
			this._logLoad = () => {
				if (this.$refs.logList && !this.$refs.logList._requestObj && this.$refs.logList.$refs.loading && this.$refs.logList.$refs.loading.getBoundingClientRect().top < this.$refs.logList.$el.getBoundingClientRect().bottom + this.$refs.logList.$el.getBoundingClientRect().height * 0.5) {
					this.$refs.logList.loadData();
				}
			};
			window.addEventListener('scroll', this._logLoad);

			this.$onShow(() => {
				this.update();
			});
		},

		beforeDestroy() {
			window.removeEventListener('scroll', this._logLoad);
		},

		methods: {
			update() {
				this.request({
					url: '/aftersale/apply/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, itemList, logList}) => {
						this.baseInfo = detailInfo;
						this.productList = itemList;
						this.setLogList(logList);
					}
				})
			},

			setLogList(logList) {
				if (!logList || !this.$refs.logList) return;
				logList.forEach(item => {
					if (!item.data_json) return;
					item.data_list = [];
					if (item.operation_type == 2) {
						item.data_json.forEach(field => {
							item.data_list.push({
								content: `【${field.字段}】: 【${field.原值 || '空'}】 → 【${field.新值 || '空'}】`
							});
						});
					} else {
						item.data_json.forEach(field => {
							let key = Object.keys(field)[0];
							item.data_list.push({
								label: key,
								content: field[key]
							});
						});
					}
				});
				this.$refs.logList.setData(logList);
			},

			resumeHandle() {
				this.$confirm({
					message: '确认恢复该申请单？',
					resolve: () => {
						this.request({
							url: '/aftersale/apply/resume',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({message: '恢复成功'});
								this.update();
							}
						});
					}
				});
			},

			suspendHandle() {
				this.$refs.suspendForm.clear();
				this.$refs.suspend.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.suspendForm.submit({
							url: '/aftersale/apply/suspend',
							dataFormatter: data => {
								data.id = this.id;
								return data;
							},
							success: () => {
								this.$message({message: '挂起成功'});
								next();
								this.update();
							}
						});
					}
				});
			},

			mapHandle() {
				this.mp.navigateTo('/pages/power', {
					power: 'openLocation',
					data: `${this.baseInfo.address_longitude},${this.baseInfo.address_latitude}`
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.customer {
		gap: .26rem;

		&-count {
			gap: .12rem;
			width: 1rem;
			height: 1rem;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			background: var(--color-main);

			b {
				font-size: .36rem;
			}
		}

		&-name {
			font-size: .32rem;
			color: #28324B;
		}

		&-tag {
			gap: .12rem;
			margin-top: .2rem;
		}
	}
</style>